import React, { memo } from 'react'
import styles from './gap.styles'
import injectSheet from 'react-jss'

const Gap = memo(({ classes, answer, active, color }) =>
  answer ? (
    <span className={classes.answer} style={{ color: color }}>
      {answer}
    </span>
  ) : (
    <span style={{ color: active ? color : null }}>______</span>
  )
)

export default injectSheet(styles)(Gap)
